import axios from 'axios';

const SSO_BASE_URL = process.env.REACT_APP_API_URL_SSO || '/tas/1.0.0';
const SSO_PATH = '/sso_redirect';

class ssoService {
    isSsoEnable(param) {
        return axios
            .post(SSO_BASE_URL + SSO_PATH, JSON.stringify(param))
            .then((res) => {
                return res;
            })
            .catch((err) => {
                console.log('res isSsoEnable redirect : ', err);
                return err;
            });
    }
}

export default ssoService;
